/*!
=========================================================
* Painel Toca da Onça — Canais (redes sociais)
=========================================================
* Estrutura pronta. Conexão real depende do login do dono (Meta, etc.).
*/
import React from "react";
import { Card, CardBody, CardTitle, Button, Row, Col, Badge } from "reactstrap";

const canais = [
  {
    nome: "WhatsApp",
    icon: "fab fa-whatsapp",
    cor: "#25d366",
    status: "conectado",
    detalhe: "Carmen ativa · 7.542 contatos",
  },
  {
    nome: "Instagram Direct",
    icon: "fab fa-instagram",
    cor: "#dc2743",
    status: "aguardando",
    detalhe: "Directs, menções e stories",
  },
  {
    nome: "Facebook Messenger",
    icon: "fab fa-facebook-messenger",
    cor: "#006aff",
    status: "aguardando",
    detalhe: "Inbox da fanpage",
  },
  {
    nome: "Facebook Página",
    icon: "fab fa-facebook",
    cor: "#1877f2",
    status: "aguardando",
    detalhe: "Comentários e publicações",
  },
];

function StatusBadge({ status }) {
  if (status === "conectado")
    return <Badge color="success" pill>● Conectado</Badge>;
  return <Badge color="warning" pill>○ Aguardando conexão</Badge>;
}

function Canais() {
  return (
    <div className="content">
      <Row>
        <Col xs="12">
          <h3 className="text-white" style={{ fontWeight: 300 }}>
            Canais conectados
          </h3>
          <p className="text-muted">
            Ligue cada rede social ao CRM. A estrutura está pronta — a conexão é 1 clique seu
            (precisa logar na conta da rede).
          </p>
        </Col>
      </Row>
      <Row>
        {canais.map((c, i) => (
          <Col lg="3" md="6" key={i}>
            <Card style={{ minHeight: "210px" }}>
              <CardBody className="text-center">
                <div
                  style={{
                    width: 64,
                    height: 64,
                    borderRadius: 18,
                    background: c.cor,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 16px",
                  }}
                >
                  <i className={c.icon} style={{ fontSize: 30, color: "#fff" }} />
                </div>
                <CardTitle tag="h4" className="text-white" style={{ marginBottom: 4 }}>
                  {c.nome}
                </CardTitle>
                <p className="text-muted" style={{ minHeight: 36 }}>{c.detalhe}</p>
                <div style={{ marginBottom: 12 }}>
                  <StatusBadge status={c.status} />
                </div>
                {c.status === "conectado" ? (
                  <Button color="success" size="sm" outline disabled>
                    Ativo
                  </Button>
                ) : (
                  <Button color="info" size="sm" tag="a" target="_blank" rel="noreferrer"
                    href="https://business.facebook.com/latest/inbox/">
                    Conectar <i className="tim-icons icon-minimal-right" style={{ fontSize: 10 }} />
                  </Button>
                )}
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default Canais;
